import $ from 'jquery';
import Typed from 'typed.js';
import throttle from 'lodash/throttle';
import { fillParentContainer } from 'fancy-textfill';

const OFFSET = getOffset();

const animate = (selector, cssClass, offsetOverride) => {
  let offset = OFFSET;
  const $elements = $(selector);

  if (offsetOverride !== undefined) {
    offset = offsetOverride;
  }

  $elements.each((i, x) => {
    const $x = $(x);
    if (
      $x.offset().top + offset < $(window).scrollTop() + $(window).height() &&
      $(window).scrollTop() < $x.offset().top + $x.height()
    ) {
      $x.addClass(cssClass);
    }
  });
};

$(document).ready(() => {
  onLoadAnimations();
  handleAnimations();

  window.addEventListener('scroll', throttle(handleAnimations, 200));
  window.addEventListener('resize', throttle(onResize, 200));

  resizeDynamicText();
  window.setTimeout(resizeDynamicText, 200);
});

function onResize() {
  window.removeEventListener('scroll', handleAnimations);
  window.addEventListener('scroll', throttle(handleAnimations, 200));
  resizeDynamicText();
}

function resizeDynamicText() {
  if (!$('.js-page-title').length) {
    return;
  }
  fillParentContainer($('.js-page-title').get()[0], {
    maxFontSize: 130,
    custom: 2,
    maxHeight: $('.js-page-title')
      .parent()
      .height(),
  });

  fillParentContainer($('.js-content-angled-text').get()[0], {
    maxFontSize: 20,
    minFontSize: 11,
    maxHeight: $('.js-content-angled-text').height(),
    maxLineHeight: 2.2,
  });

  fillParentContainer($('.js-content-angled-title').get()[0], {
    maxFontSize: 36,
    minFontSize: 11,
    maxHeight: $('.js-content-angled-title').height(),
    maxLineHeight: 2.2,
  });
}

function onLoadAnimations() {
  if (!$('.js-page-title').length) {
    return;
  }
  // if we are above tablet then animate the text in
  if (matchMedia('(min-width: 768px)').matches) {
    const text = $('.js-page-title-text').text();
    $('.js-page-title').text(text);
    resizeDynamicText();

    setTimeout(() => {
      /* eslint-disable */
      new Typed('.js-page-title', {
        stringsElement: '.js-page-title-text',
        typeSpeed: 50,
        loop: false,
        preStringTyped: () => {
          $('.js-page-title').addClass('visible');
        },
        onComplete: () => {
          const $titleLink = $('.js-page-title-link');
          $titleLink.addClass('custom-animation');
        },
      });

      /* eslint-enable */
    }, 100);
  } else {
    // Else we want to just display the text
    const text = $('.js-page-title-text').text();
    $('.js-page-title').text(text);
    $('.js-page-title').addClass('visible');

    // Add in the button
    const $titleLink = $('.js-page-title-link');
    $titleLink.addClass('custom-animation');
  }
}

function handleAnimations() {
  // Can't put them all in one debounce..
  animate('.js-fade-from-left', 'fade-from-left');
  animate('.js-fade-from-right', 'fade-from-right');
  animate('.js-fade-in', 'fade-in');
  animate('.js-custom-animation', 'custom-animation', 10);
  animate('.js-gradient-overlay', 'active');
}

function getOffset() {
  if (window.matchMedia('(max-width: 768px)').matches) {
    return 50;
  }

  if (window.matchMedia('(max-width: 991px)').matches) {
    return 150;
  }

  return 200;
}
